var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _path2, _rect6, _path3, _g3, _path4, _path5, _path6, _ellipse, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 143,
    viewBox: "0 0 156 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.447 117C100.17 117 125.886 91.0325 125.886 59C125.886 26.9675 100.17 1 68.447 1C36.7242 1 11.0078 26.9675 11.0078 59C11.0078 91.0325 36.7242 117 68.447 117Z",
    fill: "url(#paint0_linear_5233_224251)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5233_224251)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.252,
    y: 17.7031,
    width: 59.6109,
    height: 74.9306,
    rx: 16,
    fill: "url(#paint1_linear_5233_224251)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.5176,
    y: 27.3701,
    width: 50,
    height: 1,
    rx: 0.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5176,
    y: 46.3701,
    width: 47.866,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5176,
    y: 65.3701,
    width: 47.866,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5176,
    y: 84.3701,
    width: 47.866,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5176,
    y: 103.37,
    width: 47.866,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5233_224251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.573 9.4209H105.815C104.475 9.4209 103.389 10.5753 103.389 11.9994V26.3637C103.389 27.7878 104.475 28.9422 105.815 28.9422H134.573C135.913 28.9422 137 27.7878 137 26.3637V11.9994C137 10.5753 135.913 9.4209 134.573 9.4209Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.569 22.2658C112.155 22.2658 113.441 20.9674 113.441 19.3658C113.441 17.7642 112.155 16.4658 110.569 16.4658C108.983 16.4658 107.697 17.7642 107.697 19.3658C107.697 20.9674 108.983 22.2658 110.569 22.2658Z",
    fill: "#CCC6D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.271,
    y: 16.4658,
    width: 15.3171,
    height: 5.8,
    rx: 2.9,
    fill: "#D5D5D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2561 96.0046C91.4213 96.0046 97.1509 94.1214 101.912 90.8937L121.392 109.672L128.458 101.394L109.659 83.2744C113.131 78.3409 115.172 72.3093 115.172 65.7962C115.172 49.1126 101.778 35.5879 85.2561 35.5879C68.7338 35.5879 55.3398 49.1126 55.3398 65.7962C55.3398 82.4798 68.7338 96.0046 85.2561 96.0046ZM110.772 65.7969C110.772 79.9215 99.4324 91.3717 85.4445 91.3717C71.4565 91.3717 60.117 79.9215 60.117 65.7969C60.117 51.6724 71.4565 40.2222 85.4445 40.2222C99.4324 40.2222 110.772 51.6724 110.772 65.7969Z",
    fill: "#CCC6D9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_5233_224251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4424 91.867C99.8499 91.867 111.529 80.1816 111.529 65.767C111.529 51.3524 99.8499 39.667 85.4424 39.667C71.035 39.667 59.3555 51.3524 59.3555 65.767C59.3555 80.1816 71.035 91.867 85.4424 91.867Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9527 65.7659L96.2657 59.416C96.8571 58.7878 97.1812 57.9529 97.169 57.0887C97.1568 56.2245 96.8093 55.3992 96.2004 54.7881C95.5915 54.1769 94.7691 53.8282 93.908 53.816C93.047 53.8037 92.2151 54.1289 91.5891 54.7225L85.262 61.0725L78.949 54.7225C78.6452 54.3998 78.2801 54.1416 77.8751 53.963C77.4701 53.7845 77.0336 53.6892 76.5913 53.683C76.1491 53.6767 75.71 53.7595 75.3002 53.9264C74.8903 54.0934 74.518 54.3412 74.2053 54.6551C73.8925 54.969 73.6456 55.3426 73.4793 55.7539C73.3129 56.1653 73.2304 56.6059 73.2367 57.0498C73.2429 57.4936 73.3378 57.9317 73.5157 58.3382C73.6936 58.7446 73.951 59.1111 74.2725 59.416L80.5961 65.7659L74.2725 72.1159C73.951 72.4208 73.6936 72.7873 73.5157 73.1937C73.3378 73.6002 73.2429 74.0383 73.2367 74.4821C73.2304 74.926 73.3129 75.3666 73.4793 75.778C73.6456 76.1893 73.8925 76.5629 74.2053 76.8768C74.518 77.1907 74.8903 77.4385 75.3002 77.6055C75.71 77.7724 76.1491 77.8552 76.5913 77.8489C77.0336 77.8427 77.4701 77.7474 77.8751 77.5689C78.2801 77.3903 78.6452 77.1321 78.949 76.8094L85.2761 70.4594L91.6033 76.8094C92.2351 77.368 93.0554 77.6637 93.897 77.6363C94.7386 77.6089 95.5381 77.2605 96.1326 76.6621C96.7271 76.0636 97.0718 75.2602 97.0966 74.4155C97.1213 73.5708 96.8242 72.7484 96.2657 72.1159L89.9527 65.7659Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.391 109.674L128.456 101.397L129.52 102.422C130.552 103.418 131.171 104.808 131.238 106.288C131.306 107.767 130.818 109.215 129.882 110.312C128.945 111.409 127.637 112.066 126.245 112.138C124.852 112.21 123.49 111.692 122.457 110.696L121.393 109.671L121.391 109.674Z",
    fill: "#E1DCEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6048 31.0496C23.5958 30.3603 23.5102 29.6652 23.3389 28.9652C22.7384 26.5089 20.0589 24.9319 17.207 24.5611C14.3563 24.1904 11.3918 25.0341 10.2492 27.1708C9.59569 28.3924 9.50555 29.4453 9.7726 30.333C10.0385 31.216 10.6695 31.948 11.5258 32.5184C13.9134 34.1072 18.0949 34.4317 20.0026 33.7674C20.8848 33.4596 21.7468 33.0888 22.5862 32.6646C22.1062 35.4418 20.318 38.0728 17.9315 40.4436C12.745 45.5963 4.69646 49.5072 0.313313 50.9451C0.077817 51.0223 -0.0528997 51.2861 0.0203406 51.5345C0.0935808 51.7829 0.34372 51.9219 0.579216 51.8447C5.04912 50.3782 13.2543 46.3842 18.5434 41.1293C21.2758 38.4151 23.2229 35.3598 23.5553 32.1476C29.7322 28.6669 34.805 22.352 39.1419 17.0377C39.3031 16.8416 39.2817 16.5433 39.0946 16.3734C38.9076 16.2046 38.6258 16.226 38.4647 16.4233C34.3047 21.5201 29.4765 27.5832 23.6048 31.0496ZM22.7068 31.5547C22.7406 30.7798 22.6685 29.9931 22.4736 29.1993C21.9541 27.0733 19.5665 25.8161 17.0977 25.4952C15.5845 25.2991 14.0284 25.4608 12.8081 26.0359C12.0408 26.3972 11.4086 26.9212 11.0278 27.6343C10.5275 28.5695 10.4193 29.3693 10.6244 30.0478C10.8295 30.7311 11.3388 31.2801 12.0025 31.721C14.1783 33.1696 17.9856 33.4774 19.722 32.8726C20.7462 32.516 21.7401 32.0716 22.7068 31.5547Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.067,
    cy: 75.9166,
    rx: 2.87196,
    ry: 2.9,
    fill: "#E3E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5958 95.9239C25.1083 95.7299 25.6477 95.4719 26.0636 95.0985C26.5576 94.6549 26.7585 94.0837 26.8934 93.4824C27.0666 92.7098 27.1358 91.8869 27.3458 91.1131C27.4236 90.8257 27.5732 90.7171 27.6374 90.6689C27.7997 90.5471 27.9638 90.5146 28.1181 90.5268C28.3011 90.5409 28.5523 90.6144 28.7176 90.9403C28.7411 90.9869 28.7718 91.058 28.7924 91.1554C28.8074 91.2267 28.8171 91.4499 28.833 91.5419C28.8728 91.7686 28.9061 91.9952 28.9373 92.2231C29.0413 92.9815 29.1011 93.6257 29.4295 94.3225C29.8752 95.2685 30.3218 95.8472 30.9274 96.1036C31.513 96.3515 32.2131 96.3049 33.1077 96.1105C33.1928 96.0886 33.2771 96.0698 33.3604 96.0545C33.7548 95.9812 34.1319 96.2564 34.2094 96.6739C34.2868 97.0912 34.0362 97.4978 33.6453 97.5895C33.5637 97.6086 33.4833 97.6268 33.4037 97.6434C32.1949 97.9614 30.7954 99.0964 29.9821 100.09C29.7314 100.397 29.3644 101.253 28.99 101.8C28.7137 102.203 28.4033 102.469 28.1426 102.563C27.9679 102.626 27.8206 102.616 27.699 102.584C27.5223 102.538 27.3756 102.436 27.263 102.275C27.2018 102.186 27.1449 102.067 27.1178 101.916C27.1049 101.843 27.1034 101.658 27.1037 101.574C27.0274 101.295 26.934 101.022 26.866 100.741C26.7037 100.07 26.3852 99.6445 26.007 99.0829C25.6533 98.5574 25.2733 98.2271 24.7163 97.9636C24.6438 97.9448 24.0591 97.7927 23.8526 97.7053C23.551 97.5773 23.4073 97.3629 23.3551 97.2474C23.2665 97.0514 23.2573 96.8802 23.275 96.7375C23.3012 96.5268 23.3902 96.3465 23.5481 96.201C23.6459 96.1105 23.792 96.0225 23.9875 95.9796C24.1387 95.9462 24.5395 95.9268 24.5958 95.9239ZM28.0259 94.8296C28.053 94.8938 28.0819 94.9583 28.1126 95.0234C28.7653 96.4088 29.4952 97.1823 30.3824 97.5576L30.4122 97.5698C29.8186 98.0381 29.2814 98.5615 28.8707 99.0632C28.7017 99.2698 28.4778 99.699 28.236 100.139C28.0162 99.38 27.6569 98.8435 27.205 98.1721C26.8598 97.6596 26.4981 97.274 26.0536 96.9597C26.3985 96.7716 26.7275 96.5512 27.0141 96.2939C27.4913 95.8654 27.8068 95.3689 28.0259 94.8296Z",
    fill: "#CCC6D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5233_224251",
    x: 9.25195,
    y: 7.70312,
    width: 119.611,
    height: 134.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5233_224251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5233_224251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5233_224251",
    x: 96.3887,
    y: 0.420898,
    width: 59.6113,
    height: 45.5215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5233_224251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5233_224251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_5233_224251",
    x: 51.3555,
    y: 31.667,
    width: 68.1738,
    height: 68.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5233_224251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5233_224251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5233_224251",
    x1: 68.0042,
    y1: -17.8862,
    x2: 69.204,
    y2: 185.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5233_224251",
    x1: 69.0574,
    y1: 17.7031,
    x2: 69.0574,
    y2: 92.6337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.e4eb9399a299db5ac7cfbd606fd3b5e0.svg";
export { ForwardRef as ReactComponent };